module.exports = __webpack_public_path__ + "img/pdf.fae24790.svg";